
import { Card, Divider, InlineGrid, InlineStack, Link, OptionList, Text, BlockStack } from "@shopify/polaris"
import { useState } from "react"
import AppLayout from "../components/layout"

const content = [
  {
    title: 'Influencer Marketing Strategy',
    videoURL: `<div class="wistia_responsive_padding" style="padding:56.25% 0 0 0;position:relative;"><div class="wistia_responsive_wrapper" style="height:100%;left:0;position:absolute;top:0;width:100%;"><iframe src="https://fast.wistia.net/embed/iframe/irp71ts7xj?seo=false&videoFoam=true" title="tutorial-strategy Video" allow="autoplay; fullscreen" allowtransparency="true" frameborder="0" scrolling="no" class="wistia_embed" name="wistia_embed" msallowfullscreen width="100%" height="100%"></iframe></div></div><script src="https://fast.wistia.net/assets/external/E-v1.js" async></script>`,
    bodyHTML: `
`
  },
  {
    title: 'Searching for Influencers',
    videoURL: '<div class="wistia_responsive_padding" style="padding:56.25% 0 0 0;position:relative;"><div class="wistia_responsive_wrapper" style="height:100%;left:0;position:absolute;top:0;width:100%;"><iframe src="https://fast.wistia.net/embed/iframe/q282glo5f2?seo=false&videoFoam=true" title="tutorial-searching Video" allow="autoplay; fullscreen" allowtransparency="true" frameborder="0" scrolling="no" class="wistia_embed" name="wistia_embed" msallowfullscreen width="100%" height="100%"></iframe></div></div><script src="https://fast.wistia.net/assets/external/E-v1.js" async></script>',
    bodyHTML: `
`
  },
  {
    title: 'Create a Campaign',
    videoURL: '<div class="wistia_responsive_padding" style="padding:56.25% 0 0 0;position:relative;"><div class="wistia_responsive_wrapper" style="height:100%;left:0;position:absolute;top:0;width:100%;"><iframe src="https://fast.wistia.net/embed/iframe/f0y5lbjq5v?seo=false&videoFoam=true" title="tutorial-create-campaign Video" allow="autoplay; fullscreen" allowtransparency="true" frameborder="0" scrolling="no" class="wistia_embed" name="wistia_embed" msallowfullscreen width="100%" height="100%"></iframe></div></div><script src="https://fast.wistia.net/assets/external/E-v1.js" async></script>',
    bodyHTML: `
`
  },
  {
    title: 'How to Send Outreach',
    videoURL: '<div class="wistia_responsive_padding" style="padding:56.25% 0 0 0;position:relative;"><div class="wistia_responsive_wrapper" style="height:100%;left:0;position:absolute;top:0;width:100%;"><iframe src="https://fast.wistia.net/embed/iframe/nqo7m170gy?seo=false&videoFoam=true" title="tutorial-outreach Video" allow="autoplay; fullscreen" allowtransparency="true" frameborder="0" scrolling="no" class="wistia_embed" name="wistia_embed" msallowfullscreen width="100%" height="100%"></iframe></div></div><script src="https://fast.wistia.net/assets/external/E-v1.js" async></script>',
    bodyHTML: `
`
  },
  {
    title: 'Sending Contracts',
    videoURL: '<div class="wistia_responsive_padding" style="padding:56.25% 0 0 0;position:relative;"><div class="wistia_responsive_wrapper" style="height:100%;left:0;position:absolute;top:0;width:100%;"><iframe src="https://fast.wistia.net/embed/iframe/jwejbwdtp8?seo=false&videoFoam=true" title="tutorial-contracts Video" allow="autoplay; fullscreen" allowtransparency="true" frameborder="0" scrolling="no" class="wistia_embed" name="wistia_embed" msallowfullscreen width="100%" height="100%"></iframe></div></div><script src="https://fast.wistia.net/assets/external/E-v1.js" async></script>',
    bodyHTML: `
`
  },
]

export default function Tutorial() {

  const index = new URLSearchParams(window.location.search).get('index')

  const [stage, setStage] = useState(index ? content[index]?.title : 'Influencer Marketing Strategy')

  const activeStageContent = content?.find(c => c.title === stage) || content[0]

  return (
    <AppLayout>
      <InlineGrid columns="1fr 2fr">
        <BlockStack gap="500">
          <Text variant="headingLg">PartnerUp Tutorial</Text>
          <OptionList options={content?.map(c => ({ value: c.title, label: c.title }))}
            selected={[stage]}
            onChange={v => setStage(v[0])}
          />
        </BlockStack>
        <Card>
          <BlockStack gap="500">
            <Text variant="headingLg">{activeStageContent.title}</Text>
            <div dangerouslySetInnerHTML={{ __html: activeStageContent.videoURL }} />
            <div dangerouslySetInnerHTML={{ __html: activeStageContent.bodyHTML }} />
            <Divider />
            <BlockStack inlineAlign="end">
              <Text variant="bodyMd">Need more help?</Text>
              <InlineStack gap="100">
                <Link removeUnderline onClick={() => {
                  window.Beacon('toggle')
                }}>Use the chat</Link>
                <Text variant="bodyMd">or email us, support@partnerup.net</Text>
              </InlineStack>
            </BlockStack>
          </BlockStack>
        </Card>
      </InlineGrid>
    </AppLayout>
  )
}
